<template>
  <div class="">

    <div class="header">
      <b-row>
        <b-col cols="7" class="heading">
          </b-col>
        <b-col class="user">
          <b-row>
            <b-col>
              <strong>Username : Michael</strong>
            </b-col>
            <b-col>
              <strong>Role : Admin</strong>
            </b-col>
            <div class="w-100"></div>
            <b-col>
              <strong>Application : </strong>
            </b-col>
            <b-col></b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <b-navbar type="dark">
    <b-navbar-nav>
      <b-nav-item class="bli1" href="#" v-b-tooltip.hover title="home"><router-link :to="{ name: 'home'}"><img src="img/home.gif" /></router-link></b-nav-item>
      <b-nav-item class="bri1" href="#" v-b-tooltip.hover title="list"><img src="img/viewlistblue.gif" /></b-nav-item>
      <b-nav-item class="blwi1 bri1 pl50" href="#"></b-nav-item>
      <b-nav-item class="blwi1" v-b-tooltip.hover title="filter" @click="$bvModal.show('view-filter')" href="#"><img src="img/filterblue.gif" /></b-nav-item>
      <b-nav-item href="#" v-b-tooltip.hover title="view filter"><router-link :to="{ name: 'filter'}"><img src="img/viewfilterblue.gif" /></router-link></b-nav-item>
      <b-nav-item href="#" v-b-tooltip.hover title="slice"><img src="img/sliceblue.gif" /></b-nav-item>
      <b-nav-item href="#" v-b-tooltip.hover title="dice"><router-link :to="{ name: 'dice'}"><img src="img/diceblue.gif" /></router-link></b-nav-item>
      <b-nav-item href="#" v-b-tooltip.hover title="dice"><router-link :to="{ name: 'postdice'}"><img src="img/importblue.gif" /></router-link></b-nav-item>
      <b-nav-item href="#" v-b-tooltip.hover title="history"><router-link :to="{ name: 'history'}"><img src="img/historyblue.gif" /></router-link></b-nav-item>
      <b-nav-item href="#" v-b-tooltip.hover title="search" @click="$bvModal.show('history-modal')"><img src="img/searchblue.gif" /></b-nav-item>
      <b-nav-item href="#"><img src="img/groupblue.gif" /></b-nav-item>
      <b-nav-item href="#"><img src="img/groupblue.gif" /></b-nav-item>
      <b-nav-item class="bri1" v-b-tooltip.hover title="view list"><router-link :to="{ name: 'walkthrough'}"><img src="img/viewlistblue.gif" /></router-link></b-nav-item>
      <b-nav-item class="blwi1 bri1 pl50" href="#"></b-nav-item>
      <b-nav-item class="blwi1" href="#"><img src="img/printhtmlblue.gif" /></b-nav-item>
      <b-nav-item v-b-tooltip.hover title="excel" @click="$bvModal.show('excel-modal')"><img src="img/printxlblue.gif" /></b-nav-item>
      <b-nav-item v-b-tooltip.hover title="pdf" @click="$bvModal.show('pdf-modal')"><img src="img/groupblue.gif" /></b-nav-item>
      <b-nav-item class="bri1" href="#"><img src="img/printtextblue.gif" /></b-nav-item>
      <b-nav-item class="blwi1 bri1 pl50" href="#"></b-nav-item>
      <b-nav-item v-b-tooltip.hover title="document view" class="blwi1" @click="$bvModal.show('document-modal')"><img src="img/docview.gif" /></b-nav-item>
      <b-nav-item v-b-tooltip.hover title="topic map" class="" @click="$bvModal.show('topic-modal')"><img src="img/transform.gif" /></b-nav-item>
      <b-nav-item v-b-tooltip.hover title="catalog" class="bri1" href="#"><router-link :to="{ name: 'catalog'}"><img src="img/commandobject.gif" /></router-link></b-nav-item>
      <b-nav-item class="blwi1 pl15" href="#"></b-nav-item>
      <b-nav-item class="bri1" href="#"><img src="img/exitblue.gif" /></b-nav-item>
      <b-nav-item class="blwi1" href="#"></b-nav-item>
    </b-navbar-nav>
  </b-navbar>


<b-modal id="view-filter" size="lg" hide-footer>
    <template #modal-title>
      <img class="ielogo" src="img/ielogo.png" /> .. -
      <strong>Microsoft Internet Explorer</strong>
      <div class="toolicons">
      <i @click="$bvModal.hide('view-filter')" data-v-056ee09c="" aria-label="icon: underline" class="anticon anticon-underline"><svg viewBox="64 64 896 896" data-icon="underline" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1"></path></svg></i>
      <i data-v-056ee09c="" aria-label="icon: play-square" class="anticon anticon-play-square"><svg viewBox="64 64 896 896" data-icon="play-square" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"></path></svg></i>
      <a-icon type="close" @click="$bvModal.hide('view-filter')" />
    </div>
    </template>
    
    <div class="d-block text-center view-filter">
      <div class="tableDiv">
      <div class="table-header" style="text-align: center">
        <span class="tableheading">Filter</span> 
      </div>
      <div class="table-body">
        <b-row>
          <b-col>
            Column Name<br>
        <select class="round w100" style="border-bottom: 49px solid #ddd !important;">
          <option value="authorization_stage">pur_requisition_date</option>
        </select>
          </b-col>
          <b-col>
            Operator<br>
            <div class="bb-45 w100">
              <input class="filter-input" type="text" value="<" />
            <select class="round">
              <option value="authorization_stage"></option>
            </select>
            </div>
          </b-col>
          <b-col>
            Value<br>
            <div class="bb-45 w100">
              <input class="filter-input" type="text" value="today()" />
            <select class="round">
              <option value=""></option>
            </select>
            </div>
          </b-col>
          <b-col>
            <br>
            <b-button class="glass" @click="$bvModal.hide('view-filter'); $bvModal.show('view-filter-options')">Search</b-button>
          </b-col>
        </b-row>
      </div>
    </div>
    </div>
  </b-modal>

<b-modal id="view-filter-optionss" style="display:none" size="lg" hide-footer>
    <template #modal-title>
      <img class="ielogo" src="img/ielogo.png" /> .. -
      <strong>Microsoft Internet Explorer</strong>
      <div class="toolicons">
      <i @click="$bvModal.hide('view-filter-options')" data-v-056ee09c="" aria-label="icon: underline" class="anticon anticon-underline"><svg viewBox="64 64 896 896" data-icon="underline" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1"></path></svg></i>
      <i data-v-056ee09c="" aria-label="icon: play-square" class="anticon anticon-play-square"><svg viewBox="64 64 896 896" data-icon="play-square" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"></path></svg></i>
      <a-icon type="close" @click="$bvModal.hide('view-filter-options')" />
    </div>
    </template>
    
    <div class="d-block text-center view-filter-options">
      <div class="tableDiv">
      <div class="table-header" style="text-align: center">
        <span class="tableheading">Save Filter</span> 
      </div>
      <div class="table-body">
        <b-row>
          <b-col class="firstcol">
            Show onStartup :
          <a-checkbox @change="onChange">
          </a-checkbox><br>
          <a-form class="filter-form">
              <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
                  label="Filter Name : "
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
                <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
                  label="Description : "
                >
                  <a-textarea
                    style="border: 2px inset;"
                    placeholder=""
                    :auto-size="{ minRows: 3, maxRows: 5 }"
                  />
                </a-form-item>
                <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
                  label="E-Mail : "
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
            </a-form>
          </b-col>
          <b-col style="text-align: left">
            Scope: 
            <a-radio-group name="radioGroup" style="display: flex; justify-content: center; margin-top: -22px; margin-left: 45px;" :default-value="1">
              <a-radio :value="1">
                Public
              </a-radio>
              <a-radio :value="2">
                Private
              </a-radio>
              </a-radio-group>
            <a-form class="filter-form">
              Show Alert :
          <a-checkbox style="display: flex;    justify-content: center;    margin-top: -14px;    margin-left: -105px;    margin-bottom: 5px;" @change="onChange">
          </a-checkbox>
                <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
                  label="Alert Message : "
                >
                  <a-textarea
                    style="border: 2px inset;"
                    placeholder=""
                    :auto-size="{ minRows: 3, maxRows: 5 }"
                  />
                </a-form-item>
            </a-form><br>
            <b-button class="glass" style="margin-top:60px;margin-bottom:30px;" @click="$bvModal.hide('view-filter-options'); $bvModal.show('save-filter')">Save Filter</b-button>
          </b-col>
        </b-row>
      </div>
    </div>
    </div>
  </b-modal>

  <b-modal id="view-filter-options" size="xl" hide-footer>
    <template #modal-title>
      <img class="ielogo" src="img/ielogo.png" /> .. -
      <strong>Microsoft Internet Explorer</strong>
      <div class="toolicons">
      <i @click="$bvModal.hide('view-filter-options')" data-v-056ee09c="" aria-label="icon: underline" class="anticon anticon-underline"><svg viewBox="64 64 896 896" data-icon="underline" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1"></path></svg></i>
      <i data-v-056ee09c="" aria-label="icon: play-square" class="anticon anticon-play-square"><svg viewBox="64 64 896 896" data-icon="play-square" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"></path></svg></i>
      <a-icon type="close" @click="$bvModal.hide('view-filter-options')" />
    </div>
    </template>
    
    <div class="d-block text-center view-filter-options">
      <div class="tableDiv">
      <div class="table-header" style="text-align: center">
        <span class="tableheading">Filter Options : PendPR</span> 
      </div>
      <div class="table-body">
        <b-row>
          <b-col class="firstcol">
            <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
                  label="authorized : "
                >
                  <b-row>
                    <a-input
                    value="="
                    style="width: 20%"
                  />
                  <a-input
                    placeholder="Yes"
                    style="width: 50%"
                  />
                  <span style="width:20%">AND</span>
                  </b-row>
                </a-form-item>
                <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
                  label="document_status : "
                >
                  <b-row>
                    <a-input
                    value="="
                    style="width: 20%"
                  />
                  <a-input
                    placeholder="Open"
                    style="width: 50%"
                  />
                  </b-row>
                </a-form-item>
          <a-form class="filter-form">
              <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
                  label="Filter Name : "
                >
                  <a-input
                    placeholder=""
                    v-model="filterName"
                  />
                </a-form-item>
                <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
                  label="Filter Description : "
                >
                  <a-textarea
                    style="border: 2px inset;"
                    placeholder=""
                    :auto-size="{ minRows: 3, maxRows: 5 }"
                  />
                </a-form-item>
                <a-form-item
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
                  label="E-Mail : "
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
            </a-form>
          </b-col>
          <b-col style="margin-top: 50px">
            Show Alert :
          <a-checkbox @change="onChange">
          </a-checkbox>
          Show onStartup :
          <a-checkbox @change="onChange">
          </a-checkbox>
            Scope: 
            <a-radio-group name="radioGroup" :default-value="1">
              <a-radio :value="1">
                Public
              </a-radio>
              <a-radio :value="2">
                Private
              </a-radio>
              </a-radio-group>
            <a-form class="filter-form">
              
                <a-form-item
                class="text-right"
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
                  label="Alert Message : "
                >
                  <a-textarea
                    style="border: 2px inset;"
                    placeholder=""
                    :auto-size="{ minRows: 3, maxRows: 5 }"
                  />
                </a-form-item>
            </a-form><br>
          </b-col>
        </b-row>
        <b-row class="filter-btn">
            <b-button class="glass">Execute Filter</b-button>
            <b-button class="green-glass" @click="saveFilter()">Save Changes</b-button>
            <b-button class="glass">Delete Filter</b-button>
        </b-row>
      </div>
    </div>
    </div>
  </b-modal>

  <b-modal id="save-filter" size="lg" hide-footer>
    <template #modal-title>
      <img class="ielogo" src="img/ielogo.png" /> .. -
      <strong>Microsoft Internet Explorer</strong>
      <div class="toolicons">
      <i @click="$bvModal.hide('save-filter')" data-v-056ee09c="" aria-label="icon: underline" class="anticon anticon-underline"><svg viewBox="64 64 896 896" data-icon="underline" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1"></path></svg></i>
      <i data-v-056ee09c="" aria-label="icon: play-square" class="anticon anticon-play-square"><svg viewBox="64 64 896 896" data-icon="play-square" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"></path></svg></i>
      <a-icon type="close" @click="$bvModal.hide('save-filter')" />
    </div>
    </template>
    
    <div class="d-block text-center save-filter">
      <div class="tableDiv">
      <div class="table-header" style="text-align: center">
        <span class="tableheading">TestFil saved.</span> 
      </div>
      <div class="table-body">
        <b-row class="save-filter-btn">
            <b-button class="glass" @click="$bvModal.hide('save-filter')" style="margin-bottom:10px;">New Filter</b-button>
            <b-button class="glass" @click="$bvModal.hide('save-filter')">List Filters</b-button>
        </b-row>
      </div>
    </div>
    </div>
  </b-modal>

<b-modal id="document-modal" size="lg" hide-footer>
    <template #modal-title>
      <img class="ielogo" src="img/ielogo.png" /> .. -
      <strong>Document View - PurchaseRequisition - Microsoft Internet Explorer </strong>
      <div class="toolicons">
      <i @click="$bvModal.hide('document-modal')" data-v-056ee09c="" aria-label="icon: underline" class="anticon anticon-underline"><svg viewBox="64 64 896 896" data-icon="underline" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1"></path></svg></i>
      <i data-v-056ee09c="" aria-label="icon: play-square" class="anticon anticon-play-square"><svg viewBox="64 64 896 896" data-icon="play-square" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"></path></svg></i>
      <a-icon type="close" @click="$bvModal.hide('document-modal')" />
    </div>
    </template>
    
    <div class="d-block text-center">
      <div class="tableDiv">
      <div class="table-header">
        <b-row>
          <b-col cols="12" md="8"></b-col>
          <b-col cols="6" md="4" style="padding-top: 15px">
            <img src="img/movefirst.gif" />
            <img src="img/prev.gif" />
            <img @click="$bvModal.hide('document-modal'); $bvModal.show('pur-document-modal')" src="img/next.gif" />
            <img @click="$bvModal.hide('document-modal'); $bvModal.show('pur-document-modal')" src="img/movelast.gif" />
            <br>
            <span style="color: #ff0000">1 of 20</span>
          </b-col>
        </b-row>
      </div>
      <div class="table-body">
            <h6 class="doc-h6"><a-icon style="vertical-align: 0.125em; color: yellow;" type="caret-down" /> Pur Requisition</h6>
        <div class="document-body">
          <div class="document-header">
            <h6 class="">Pur Requisition Header</h6>
            <a-form class="filter-form document-form">
            <h6 class="doc-h6"><a-icon style="vertical-align: 0.125em; color: yellow;" type="caret-down" /> General</h6>
              <a-form-item
              style="margin-top:15px;"
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Pur Requisition No"
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
                <a-form-item
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Pur Requisition Date"
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
                <a-form-item
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Pur Requisition Type"
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
                <a-form-item
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Ref No"
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
                <a-form-item
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Authorized"
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
                <a-form-item
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Authorization Stage"
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
                <a-form-item
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Cancel/Reject"
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
                <a-form-item
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Total Estimated Cost"
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
                
                <a-form-item
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Remarks"
                >
                  <a-textarea
                    style="border: 2px inset;"
                    placeholder=""
                    :auto-size="{ minRows: 3, maxRows: 5 }"
                  />
                </a-form-item>
        </a-form>
          </div>
        </div>
      </div>
    </div>
    </div>
  </b-modal>

  <b-modal id="pur-document-modal" size="lg" hide-footer>
    <template #modal-title>
      <img class="ielogo" src="img/ielogo.png" /> .. -
      <strong>Document View - PurchaseRequisition - Microsoft Internet Explorer </strong>
      <div class="toolicons">
      <i @click="$bvModal.hide('pur-document-modal')" data-v-056ee09c="" aria-label="icon: underline" class="anticon anticon-underline"><svg viewBox="64 64 896 896" data-icon="underline" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1"></path></svg></i>
      <i data-v-056ee09c="" aria-label="icon: play-square" class="anticon anticon-play-square"><svg viewBox="64 64 896 896" data-icon="play-square" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"></path></svg></i>
      <a-icon type="close" @click="$bvModal.hide('pur-document-modal')" />
    </div>
    </template>
    
    <div class="d-block text-center">
      <div class="tableDiv">
      <div class="table-header">
        <b-row>
          <b-col cols="12" md="8"></b-col>
          <b-col cols="6" md="4" style="padding-top: 15px">
            <img @click="$bvModal.hide('pur-document-modal'); $bvModal.show('document-modal')" src="img/movefirst.gif" />
            <img @click="$bvModal.hide('pur-document-modal'); $bvModal.show('document-modal')" src="img/prev.gif" />
            <img src="img/next.gif" />
            <img src="img/movelast.gif" />
            <br>
            <span style="color: #ff0000">1 of 20</span>
          </b-col>
        </b-row>
      </div>
      <div>
        <img style="width:100%" src="img/icons.png" />
      </div>
      <div class="table-body">
            <h6 class="doc-h6"><a-icon style="vertical-align: 0.125em; color: yellow;" type="caret-down" /> Pur Requisition</h6>
        <div class="document-body">
          <div class="document-header">
            <h6 class="">Pur Requisition Header</h6>
            <a-form class="filter-form document-form">
            <h6 class="doc-h6"><a-icon style="vertical-align: 0.125em; color: yellow;" type="caret-down" /> General</h6>
              <a-form-item
              style="margin-top:15px;"
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Pur Order No"
                >
                  <a-input
                    placeholder=""
                    value="PO/000001"
                  />
                </a-form-item>
                <a-form-item
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Pur Order Date"
                >
                  <a-input
                    placeholder=""
                    value="31/02/2020"
                  />
                </a-form-item>
                <a-form-item
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Pur Order Type"
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
                <a-form-item
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Vendor Code"
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
                <a-form-item
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Vendor Name"
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
                <a-form-item
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Pur Requisition No"
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
                <a-form-item
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Blanket Po No"
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
                <a-form-item
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Pur Quotation No"
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
                
                <a-form-item
              :label-col="docLabelCol"
              :wrapper-col="docWrapperCol"
                  label="Payment Terms Code"
                >
                  <a-input
                    placeholder=""
                  />
                </a-form-item>
        </a-form>
          </div>
        </div>
      </div>
    </div>
    </div>
  </b-modal>

<b-modal id="topic-modal" size="xl" hide-footer>
    <template #modal-title>
      <img class="ielogo" src="img/ielogo.png" /> .. -
      <strong>Microsoft Internet Explorer</strong>
      <div class="toolicons">
      <i @click="$bvModal.hide('topic-modal')" data-v-056ee09c="" aria-label="icon: underline" class="anticon anticon-underline"><svg viewBox="64 64 896 896" data-icon="underline" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1"></path></svg></i>
      <i data-v-056ee09c="" aria-label="icon: play-square" class="anticon anticon-play-square"><svg viewBox="64 64 896 896" data-icon="play-square" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"></path></svg></i>
      <a-icon type="close" @click="$bvModal.hide('topic-modal')" />
    </div>
    </template>
    
    <div class="d-block text-center save-filter">
      
      <b-row>

        <b-col md="2" style="border-right: 2px inset #333">
          <h6>Topic List</h6>
          <div>
          <a href="#">Item\</a> <a style="padding-left:25px;" href="#">Hardware</a> <br><a href="#" style="color: red">Hard Disk</a><br>
          <a href="#">Item\</a> <a style="padding-left:25px;" href="#">Software</a> <br><a href="#">Open<br> TopicMap</a><br>
          <a href="#">Item\</a> <a style="padding-left:25px;" href="#">Software</a> <br><a href="#">Error<br> in html</a><br>
          </div>
        </b-col>

        <b-col md="10">
            <div>
              <b-tabs content-class="mt-3" align="center">
                <b-tab title="InfoManager" active>
                  <b-row style="margin-top:45px; margin-bottom: 30px;">
                    <b-col md="1"></b-col>
                    <b-col md="3" style="height: 300px; border: 1px solid; padding: 0; border-radius: 5px;">
                      <div class="table-header">
                        <h6 style="text-align: center;">CPU</h6>
                        
                      </div>
                      <b-list-group>
                        <b-list-group-item>Mother Board Problem</b-list-group-item>
                        <b-list-group-item style="color: #ff0000">Hard Disk</b-list-group-item>
                        <b-list-group-item>System Slow</b-list-group-item>
                      </b-list-group>
                      <b-button class="pink-glass" style="margin-top: 110px;">Add Topic</b-button>
                    </b-col>
                    <b-col md="1"></b-col>
                    <b-col md="7" style="height: 300px; border: 1px solid; padding: 0; border-radius: 5px;">
                      <div class="table-header">
                        <h6 style="text-align: center;">Hard Disk</h6>
                      </div>
                      <div style="text-align: left; padding: 5px; height: 150px; border: 2px inset; overflow-y:scroll;">
                          <p>Hard Disk ?<br>
                          Replace it.</p>
                        </div>
                      <b-button class="pink-glass" style="margin-top: 85px;">Edit</b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="1"></b-col>
                    <b-col md="3" style="height: 300px; border: 1px solid; padding: 0; border-radius: 5px;">
                      <div class="table-header">
                        <h6 style="text-align: center;">Recent Topics</h6>
                        
                      </div>
                      <b-list-group>
                        <b-list-group-item style="background: #e8e8e8;">This column lists all instances created on this day</b-list-group-item>
                      </b-list-group>
                    </b-col>
                    <b-col md="1"></b-col>
                    <b-col md="7" style="height: 300px; border: 1px solid; padding: 0; border-radius: 5px;">
                      <div class="table-header">
                        <h6 style="text-align: center;">Details</h6>
                      </div>
                      <div style="text-align: left; padding: 5px; height: 150px; border: 2px inset; overflow-y:scroll;">
                          <table class="topic-table">
                            <tr>
                              <td>Category</td>
                              <td>:</td>
                              <td>Hardware</td>
                            </tr>
                            <tr>
                              <td>Parts</td>
                              <td>:</td>
                              <td>CPU</td>
                            </tr>
                            <tr>
                              <td>Problem</td>
                              <td>:</td>
                              <td>Not available</td>
                            </tr>
                            <tr>
                              <td>Problem1</td>
                              <td>:</td>
                              <td>Not available</td>
                            </tr>
                          </table>
                        </div>
                      <b-button class="green-glass" >Edit Property</b-button>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab title="Procure"><p>Procure</p></b-tab>
                <b-tab title="e-Smart"><p>e-Smart!</p></b-tab>
              </b-tabs>
              <div class="pink-glass" style="position: absolute; top: 48px; height: 20px; border-radius: 0; width: 100%; left: 186px;"></div>
            </div>
        </b-col>

      </b-row>
      
    </div>
  </b-modal>

<b-modal id="history-modal" size="lg" hide-footer>
    <template #modal-title>
      <img class="ielogo" src="img/ielogo.png" /> .. -
      <strong>Microsoft Internet Explorer</strong>
      <div class="toolicons">
      <i @click="$bvModal.hide('history-modal')" data-v-056ee09c="" aria-label="icon: underline" class="anticon anticon-underline"><svg viewBox="64 64 896 896" data-icon="underline" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1"></path></svg></i>
      <i data-v-056ee09c="" aria-label="icon: play-square" class="anticon anticon-play-square"><svg viewBox="64 64 896 896" data-icon="play-square" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"></path></svg></i>
      <a-icon type="close" @click="$bvModal.hide('history-modal')" />
    </div>
    </template>
    
    <div class="d-block text-center">
      <div class="tableDiv">
      <div class="table-header" style="text-align: center">
        <span class="tableheading">Search : PurchaseRequisitionView</span> 
      </div>
      <div class="table-body">
        <b-row>
          <b-col>
            Column Name<br>
        <select class="round">
          <option value="authorization_stage">authorization_stage</option>
        </select>
          </b-col>
          <b-col>
            Value<br>
            <input type="text" value="0" />
          </b-col>
          <b-col>
            <br>
            <b-button class="glass" @click="gotoGroups">Search</b-button>
          </b-col>
        </b-row>
      </div>
    </div>
    </div>
  </b-modal>

<b-modal id="excel-modal" size="xl" hide-footer>
    <template #modal-title>
      <img class="ielogo" src="img/ielogo.png" /> .. -
      <strong>http://com.app:8080/servlet/com.entwin.AppServlet - Microsoft Internet Explorer</strong>
      <div class="toolicons">
      <i @click="$bvModal.hide('excel-modal')" data-v-056ee09c="" aria-label="icon: underline" class="anticon anticon-underline"><svg viewBox="64 64 896 896" data-icon="underline" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1"></path></svg></i>
      <i data-v-056ee09c="" aria-label="icon: play-square" class="anticon anticon-play-square"><svg viewBox="64 64 896 896" data-icon="play-square" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"></path></svg></i>
      <a-icon type="close" @click="$bvModal.hide('excel-modal')" />
    </div>
    </template>
    <div>
      <img style="width: 100%" src="img/toolb.png" />
    </div>
    <div class="d-block text-center excel-modal">
      <div class="tableDiv">
      <div class="table-body">
        <b-row class="">
          <table style="width:100%">
            <tr>
                <th>&nbsp;</th>
                <th>A</th>
                <th>B</th>
                <th>C</th>
                <th>D</th>
                <th>E</th>
                <th>F</th>
                <th>G</th>
                <th>H</th>
                <th>I</th>
                <th>J</th>
                <th>K</th>
              </tr>
              <tr>
                <th></th>
                <th>pur_requisition_no</th>
                <th>pur_requisition_date</th>
                <th>pur_requisition_type</th>
                <th>ref_no</th>
                <th>authorized</th>
                <th>authorization_stage</th>
                <th>cancel_rejection</th>
                <th>total_estimation</th>
                <th>remarks</th>
                <th>document_no</th>
                <th>plan_no</th>
              </tr>
              <tr>
              <td>1</td>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
                <td>0</td>
                <td>Yes</td>
                <td>3</td>
                <td>No</td>
                <td>98800</td>
                <td> </td>
                <td>Open</td>
                <td>0</td>
              </tr>
              <tr>
              <td>2</td>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
                <td>0</td>
                <td>Yes</td>
                <td>3</td>
                <td>No</td>
                <td>98800</td>
                <td> </td>
                <td>Open</td>
                <td>0</td>
              </tr>
              <tr>
              <td>3</td>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
                <td>0</td>
                <td>Yes</td>
                <td>3</td>
                <td>No</td>
                <td>98800</td>
                <td> </td>
                <td>Open</td>
                <td>0</td>
              </tr>
              <tr>
              <td>4</td>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
                <td>0</td>
                <td>Yes</td>
                <td>3</td>
                <td>No</td>
                <td>98800</td>
                <td> </td>
                <td>Open</td>
                <td>0</td>
              </tr>
              <tr>
              <td>5</td>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
                <td>0</td>
                <td>Yes</td>
                <td>3</td>
                <td>No</td>
                <td>98800</td>
                <td> </td>
                <td>Open</td>
                <td>0</td>
              </tr>
              <tr>
              <td>6</td>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
                <td>0</td>
                <td>Yes</td>
                <td>3</td>
                <td>No</td>
                <td>98800</td>
                <td> </td>
                <td>Open</td>
                <td>0</td>
              </tr>
              <tr>
              <td>7</td>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
                <td>0</td>
                <td>Yes</td>
                <td>3</td>
                <td>No</td>
                <td>98800</td>
                <td> </td>
                <td>Open</td>
                <td>0</td>
              </tr>
              <tr>
              <td>8</td>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
                <td>0</td>
                <td>Yes</td>
                <td>3</td>
                <td>No</td>
                <td>98800</td>
                <td> </td>
                <td>Open</td>
                <td>0</td>
              </tr>
              <tr>
              <td>9</td>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
                <td>0</td>
                <td>Yes</td>
                <td>3</td>
                <td>No</td>
                <td>98800</td>
                <td> </td>
                <td>Open</td>
                <td>0</td>
              </tr>
            </table>
        </b-row>
      </div>
    </div>
    </div>
  </b-modal>

  <b-modal id="pdf-modal" size="xl" hide-footer>
    <template #modal-title>
      <img class="ielogo" src="img/ielogo.png" /> .. -
      <strong>http://com.app:8080/servlet/com.entwin.AppServlet - Microsoft Internet Explorer</strong>
      <div class="toolicons">
      <i @click="$bvModal.hide('pdf-modal')" data-v-056ee09c="" aria-label="icon: underline" class="anticon anticon-underline"><svg viewBox="64 64 896 896" data-icon="underline" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1"></path></svg></i>
      <i data-v-056ee09c="" aria-label="icon: play-square" class="anticon anticon-play-square"><svg viewBox="64 64 896 896" data-icon="play-square" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"></path></svg></i>
      <a-icon type="close" @click="$bvModal.hide('pdf-modal')" />
    </div>
    </template>
    <div>
      <img style="width: 100%" src="img/toolpdf.png" />
    </div>
    <div class="d-block text-center">
      <div class="tableDiv">
      <div class="table-body">
        <b-row class="">
          <table style="width:100%; border: 1px solid;">
            <tr>
                <th colspan="3">PurchaseRequisitionView</th>
              </tr>
              <tr>
                <th>pur_requisition_no</th>
                <th>pur_requisition_date</th>
                <th>pur_requisition_type</th>
              </tr>
              <tr>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
              </tr>
              <tr>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
              </tr>
              <tr>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
              </tr>
              <tr>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
              </tr>
              <tr>
              <tr>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
              </tr>
              <tr>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
              </tr>
              <tr>
              <tr>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
              </tr>
              <tr>
                <td>PR/051/2020</td>
                <td>2020-06-19 00:00:00.000</td>
                <td>Manual</td>
              </tr>
            </table>
        </b-row>
      </div>
    </div>
    </div>
  </b-modal>

  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
      return {
        filterName: "",
        filtersArr: [],
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
        docLabelCol: { span: 6 },
        docWrapperCol: { span: 10 },
      }
  },
  methods: {
    gotoGroups(){
      this.$router.push('/group')
    },
    onChange(e) {
          this.checked = e.target.checked;
        },
        saveFilter(){
        const getFiltersArr = []
        getFiltersArr.push(this.filterName)
        localStorage.setItem('getFiltersArr', JSON.stringify(getFiltersArr))
          this.$root.$emit("bv::hide::modal", "view-filter-options");
          // window.location.reload()
          this.$router.go('/filter')
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a{
  color: blue !important;
}
.topic-table > tr > td{
  min-width: 50px;
}
.topic-table > tr > td:first-child{
  text-align: right;
}
.topic-table > tr > td:first-child, .topic-table > tr > td:last-child{
  width: 250px;
  border: 1px solid #fff
}
.green-glass{
  position: relative;
    display: inline-block;
        padding: 0px 15px;
    border: 0;
    background-color: green;
    background-image: linear-gradient(lightgreen,#66b266,lightgreen);
    text-decoration: none;
    color: #333;
    font-size: 14px;
    font-family: sans-serif;
    font-weight: 700;
    box-shadow: rgb(0 0 0 / 25%) 1.95px 1.95px 2.6px;
    border-radius: 15px;
    margin-right: 5px;
    max-width: 135px;
}
#topic-modal .table-header{
  background: #eedaff;
}
.filter-input{
      width: 72%;
    margin-right: 6px;
    border-right: 3px solid #ddd;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.heading{
  background: url('../../public/img/logo.png');
  background-repeat: no-repeat;
  background-size: 18%;
  height: 90px;
}
.heading h1{
  color: #fff;
  text-shadow: 4px 4px 4px grey;
  font-family: 'Merriweather', serif;
  padding-top: 15px;
}
.user{
  padding-top: 15px;
  text-align: left;
}
.user .col{
  padding-top: 5px;
  padding-bottom: 5px;
  font-family: 'Kanit', sans-serif;
}
.view-filter .tableDiv{
  border: 1px solid;
  margin: 20px 0px 15px 5px;
  border-radius: 5px;
  text-align: left;
  min-width: 1200px;
  margin-bottom: 100px;
    padding-bottom: 50px;
}
.table-header{
  background: #bdc7d6;
  text-align: left;
  border-bottom: 1px solid;
}
.tableimg{
  padding-left: 10px;
    padding-right: 10px;
    width: 30px;
    margin-top: -4px;
}
.tableheading{
  padding-left: 10px;
      font-size: 14px;
    font-weight: 700;
}
.table-body{
      text-align: center;
    padding: 5px;
}
.table-body select, .table-body input{
  border: 2px inset;
}
.page{
  padding-top: 5px !important;
  padding-left: 15px !important;
   font-weight:500;
    font-size: 12px;
}
.ielogo{
  width: 20px;
  margin-left: 5px;
}
.toolicons{
      position: absolute;
      right: 3px;
    top: -2px;
}
.toolicons .anticon{
      background: #c0c0c0;
    border: 2px outset;
    margin-right: 2px;
    color: #333;
}
.pink-glass{
    position: relative;
    display: inline-block;
    padding: 2px 18px;
    border: 0;
    background-color: green;
    background-image: linear-gradient(#eedaff,#d6c4e5,#eedaff);
    text-decoration: none;
        color: #333;
    font-size: 12px;
    font-family: sans-serif;
    font-weight: 700;
    box-shadow: rgb(0 0 0 / 25%) 1.95px 1.95px 2.6px;
    border-radius: 15px;
}
.glass{
    position: relative;
    display: inline-block;
    padding: 2px 18px;
    border: 0;
    background-color: green;
    background-image: linear-gradient(#d8e1e9,#c1cfdc,#d8e1e9);
    text-decoration: none;
        color: #333;
    font-size: 12px;
    font-family: sans-serif;
    font-weight: 700;
    box-shadow: rgb(0 0 0 / 25%) 1.95px 1.95px 2.6px;
    border-radius: 15px;
    margin-right: 5px;
    max-width: 135px;
}
select {

  /* styling */
  background-color: white;
  border: thin solid blue;
  border-radius: 0px;
  display: inline-block;
  font: inherit;
  line-height: 1.5em;
  padding: 0em 3.5em 0em 0.5em;

  /* reset */

  margin: 0;      
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
}
select.round {
background-image: linear-gradient( 
45deg, transparent 30%, gray 74%), linear-gradient( 
135deg, gray 68%, transparent 36%), radial-gradient(#c0c0c0 100%, transparent 50%);
    background-position: calc(100% - 12px) calc(1em + -5px), calc(100% - 8px) calc(1em + -5px), calc(100% - 0em) 0em;
    background-size: 5px 5px, 5px 5px, 1.5em 1.5em;
    background-repeat: no-repeat;
    border: 2px inset;
    }
  .bb-45{
    border-bottom: 45px solid #ddd !important;
  }
  .view-filter-options .tableDiv{
  border: 1px solid;
  margin: 20px 0px 15px 5px;
  border-radius: 5px;
  text-align: left;
  min-width: auto;
}

.firstcol{
  text-align: left;
}
.document-body{
  padding: 50px;
}
.document-header{
  padding: 50px;
  background: #d6d3c4;
}
.document-form{
  background: #f6f3da;
  padding: 5px;
  border: 2px solid #5667af;
  box-shadow: rgb(0 0 0 / 40%) 2.95px 2.95px 2.6px;
}
.doc-h6{
      position: absolute;
    background: #5263ad;
    color: #fff;
    padding: 2px;
    margin-left: -5px;
    margin-top: -5px;
}
.save-filter-btn{
      display: table;
    margin-top: 30px;
    margin-bottom: 30px;
    margin-left: auto;
    margin-right: auto;
}
.filter-btn{
    display: flex;
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 30px;
}
</style>
